import React from "react";
import PropTypes from "prop-types";
import { Text, Modal, Flex, Box, Button, Heading } from "samba-ui";
import styled from "styled-components";
import DashboardUsersList from "./DashboardUsersList";

const StyledButton = styled(Button)`
  float: right;
`;

const DeleteDashboardModal = ({
  dashboardName,
  isOpen,
  onClose,
  onSubmit,
  users
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header borderColor="#d6d6d6 !important">
        <Heading fontSize={2} fontWeight={500} color="secondary">
          Delete Dashboard {dashboardName}
        </Heading>
      </Modal.Header>
      <Modal.Content borderColor="#d6d6d6 !important">
        <Box mb={2}>
          {users.length ? (
            <DashboardUsersList users={users} />
          ) : (
            <Text>Are you sure you want to delete this dashboard?</Text>
          )}
        </Box>
      </Modal.Content>
      <Modal.Actions
        justifyContent="space-between"
        borderColor="#d6d6d6 !important"
      >
        <Flex justifyContent="flex-end" width={"100%"}>
          <Box mr={3}>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Box>
          <StyledButton
            disabled={users.length}
            variant="destructive"
            onClick={() => {
              onClose();
              onSubmit();
            }}
          >
            Delete
          </StyledButton>
        </Flex>
      </Modal.Actions>
    </Modal>
  );
};

DeleteDashboardModal.propTypes = {
  dashboardName: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  users: PropTypes.array
};

export default DeleteDashboardModal;
